import { render, staticRenderFns } from "./real-name.vue?vue&type=template&id=337d286a&scoped=true"
import script from "./real-name.vue?vue&type=script&lang=js"
export * from "./real-name.vue?vue&type=script&lang=js"
import style0 from "./real-name.vue?vue&type=style&index=0&id=337d286a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d286a",
  null
  
)

export default component.exports